import { get } from 'lodash';
import { useState, useEffect } from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { fetchLanguages, fetchTemplateData, fetchConsentAgreement } from '../actions';

const useScreenings = (token, providerId, templateId, language) => {
  const [state, setState] = useState({
    token,
    consentAgreement: null,
    templateData: null,
    language: language,
    languages: [],
  });

  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsLoading(true);
        const templateData = await fetchTemplateData(token, templateId, language, providerId);
        const tokenData = { token : token};
        const consentAgreement = await fetchConsentAgreement(tokenData, state.language);
        const languagesData = await fetchLanguages(tokenData);
        const languages = languagesData.map((language) => ({display_name: language.attributes.name, value: language.id}))

        setState({
          token,
          consentAgreement,
          templateData,
          language,
          languages,
        });
        setError(false)
        setIsLoading(false);
      } catch (error) {
        setIsLoading(false);
        setError('Error:', error);
      }
    };

    fetchData();
  }, [token, language]);

  return {
    error,
    isLoading,
    state,
    setState,
  };
};

export default useScreenings;
